<template>
  <div class="coupon">
    <div class="couponBox" v-if="couponBox" v-loading='loading'>
      <div class="close" @click='CloseBox'></div>
      <div class="couponName">
        <div class="logo_share">
          <el-avatar class="user_share_icon" icon="el-icon-user-solid" :src="logo"></el-avatar>{{list.RealName}} {{$t('base.sharedCoupon')}} 
        </div>
        <!-- <div>Shared a Card Hobby  coupon to you</div> -->
      </div>
      <div class="couponOrder">
        <div class="couponPrice">{{list.FreeMoney}}</div>
      </div>
      <span class="endsTime">{{$t('colon.expireTime')}} {{list.LinkTime|setTime}}</span>
      <div class="getNow" @click="GetNow()">{{$t('base.getnow')}}</div>
    </div>
    <div class="couponMask"></div>
  </div>
</template>
<script>
import { getTime, getInfo } from "@/api/public";
import qs from 'qs'
export default {
  name: '',
  components: {},
  data() {
    return {
      loading: false,
      couponBox: false,
      userInfo: '',
      istype: '',
      logo: '',
      list: null,
    }
  },
  filters: {
    setTime(val) {
      return getTime(val, -8)
    }
  },
  props: {
    type: String,
    Id: String,
    Mid: String
  },
  mounted() {},
  created() {
    let id = this.$route.query.e
    let mid = this.$route.query.t
    let logo = this.$route.query.m
    this.logo = decodeURIComponent(logo)
    this.istype = this.type

    if (!this.isMobileDevice()) {
      if (this.istype != 'home') {
        this.$router.push({ path: '/', query: { e: id, t: mid ,m:logo} })
      } else {
      console.log(id,mid)
        this.couponBox=true
        this.GetShareCoupon(id, mid)
      }
    } else {
      console.log(id,mid)
      //this.GetShareCoupon(id, mid)
      this.$router.push({ path: '/sharecoupon', query: { e: id, t: mid,m:logo} })
    }
  },
  methods: {
    isMobileDevice() { //判断当前设备是否为移动端
      const ua = navigator.userAgent.toLowerCase();
      const t1 = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        ua
      );
      const t2 = !ua.match("iphone") && navigator.maxTouchPoints > 1;
      return t1 || t2;
    },
    GetShareCoupon(i, v) {
      let that = this
      that.loading = true
      console.log('data',i, v)
      let data = { memberId: v, orderId: i }
      console.log('data',data)
      this.$get(this.$interface.GetShareCoupon, data).then(res => {
        if (res.result != 0) {
          that.couponBox = true
          that.list = res.data
        } else {
          that.couponBox = false
          this.$alert(that.$enumInfo.error['NOShare'], '', {
            confirmButtonText: 'Sure',
            lockScroll: false,
            callback: action => {}
          });
        }
        that.loading = false
      })
    },
    CloseBox() {
      this.$emit('getDialog', false)
    },
    GetNow() {
      if (this.istype == 'home') {
        let userInfo = getInfo()
        if (userInfo == undefined || userInfo == null || userInfo == '') {
          this.$alert('<div style="text-align: center;font-size:18px;">Please log in</div>', 'Confirm Item', {
            dangerouslyUseHTMLString: true,
            lockScroll: false,
            confirmButtonText: 'Done',
            callback: action => {
              this.$router.push({ path: '/login' })
            }
          });
        } else {
          let data = { CouponId: this.list.CouponId, OrderId: this.list.OrderId, RealName: userInfo.NickName, operator_id: userInfo.MappingUserId, memberId: userInfo.MappingUserId, token: userInfo.ChineseToken }
          this.$post(this.$interface.DrawCoupon, qs.stringify(data)).then(res => {
            if (res.result != 0) {
              this.CloseBox();
              this.$router.push({ path: '/mycardhobby/coupons' })
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              });
            }
          })
        }
      } else {
        var u = navigator.userAgent
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        var url = { open: "#", down: "http://a.app.qq.com/o/simple.jsp?pkgname=com.katao54.card" };
        if (isAndroid) {
          url.open = "CardApp://card.app/buy?id=@Model.ID&type=3";
        }
        var iframe = document.createElement("iframe");
        // iframe.style.display = "none";

        var timer = null;
        if (isAndroid) {
          document.body.appendChild(iframe);
          iframe.src = url.open;
          timer = setTimeout(function() { location.href = url.down; }, 2000);
        } else {
          window.location.href = url.down;
          console.log(url)
        }
        // 移动端
      }
    },
    PayBack() {
      let that = this
      let ua = navigator.userAgent.toLowerCase();
      //android终端
      let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
      //ios终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

      let data = { "status": this.isPay ? 1 : 0, "type": this.isText }
      if (!isAndroid) {
        //ios
        console.log(" 我是ios")
        //这里是和IOS商量好的写法，调用IOS的finishActivity方法
        try {
          window.webkit.messageHandlers.PayCallback.postMessage(data)
        } catch (error) {
          console.log('WKWebView post message');
        }
      } else if (isAndroid) {
        //android
        console.log("我是android");
        //这里是和安卓商量好的写法，调用安卓的finishActivity方法
        //android.finishActivity();            
      }
    }
  },
}

</script>
<style scoped>
.coupon {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.couponBox {
  width: 320px;
  height: 250px;
  margin: 0 auto;
  z-index: 3;
  background: url(../../static/images/coupon2.png);
  background-size: contain;
  position: relative;
}

.close {
  display: none;
}

.home .close {
  position: absolute;
  width: 33px;
  height: 33px;
  top: 28px;
  right: 68px;
  z-index: 3;
  cursor: pointer;
  display: block;
}

.home .couponBox {
  width: 619px;
  height: 485px;
  background: url(../../static/images/coupon.png);
}

.couponMask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  background: url(../../static/images/sharebg.jpg) no-repeat;
  background-size: cover;
}

.home .couponMask {
  background: rgba(0, 0, 0, 0.6);
}

.getNow {
  position: absolute;
  background: linear-gradient(to bottom right, #d69d5c, #a96c3f);
  border-radius: 10px;
  padding: 0 35px;
  text-align: center;
  line-height: 29px;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
  bottom: 30px;
  left: 87px;
  overflow: hidden;
}

.home .getNow {
  border: 1px solid;
  border-image: linear-gradient(to bottom right, #a96c3f, #d69d5c);
  bottom: 63px;
  left: 165px;
  width: 265px;
  height: 60px;
  font-size: 24px;
  line-height: 60px;
}

.endsTime {
  position: absolute;
  line-height: 1;
  text-align: center;
  color: #999;
  bottom: 70px;
  left: 58px;
  font-size: 12px;
}

.home .endsTime {
  width: 370px;
  bottom: 153px;
  left: 110px;
  font-size: 18px;
}

.couponOrder {
  text-align: center;
  position: absolute;
  top: 90px;
  left: 57px;
  width: 171px;
  height: 65px;
  font-size: 12px;
}

.home .couponOrder {
  width: 332px;
  height: 125px;
  top: 175px;
  left: 110px;
  padding-top: 23px;
  font-size: 14px;
}

.couponPrice {
  color: #945320;
  font-weight: bold;
  font-size: 24px;
  margin-bottom: -2px;
  margin-top: 20px;
}

.home .couponPrice {
  font-size: 48px;
  margin-top: 4px;
  margin-bottom: 3px;
}

.couponPrice:before {
  content: "$";
  font-weight: normal;
  font-size: 12px;
}

.couponPrice::after {
  content: "OFF";
  display: block;
  font-weight: normal;
  position: relative;
  font-size: 12px;
  top: -2px;
}

.home .couponPrice:before {
  font-size: 24px;
}

.home .couponPrice::after {
  font-size: 24px;
  top: -7px;
}

.couponName {
  position: relative;
  left: 57px;
  width: 192px;
  top: 30px;
}

.home .couponName {
  font-weight: 700;
  line-height: 2;
  width: 400px;
  left: 110px;
  font-size: 18px;
  top: 95px;
}

.user_share_icon {
  width: 32px;
  height: 32px;
  line-height: 16px;
  font-size: 12px;
  margin-right: 5px;
  display: inline-block;
  float: left;
}

.logo_share {
  /*display: flex;
  align-items: center;*/
}

</style>



// WEBPACK FOOTER //
// src/components/getcoupon.vue